<template>
 <p>404 - Not Found</p>
</template>

<script>
export default {
  name: 'Page404',
  components: {},
  data () {
    return {
    }
  },
  created () {
    // do something after a vue instance was created

  },
  mounted () {

  },
  methods: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
p {
  font-size: 1.5rem;
  margin: 1rem 0 0 1.5rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/page404/page404.vue